import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Pagination } from '../../../models/pagination';
import { OrdenCompraService } from '../../../services/orden-compra.service';
import { OrdenCompra } from '../../../models/orden-compra';
@Component({
  selector: 'app-orden-compra-add-modal',
  templateUrl: './orden-compra-add-modal.component.html',
  styleUrls: ['./orden-compra-add-modal.component.css'],
  providers: [
    OrdenCompraService
  ]
})
export class OrdenCompraAddModalComponent implements OnInit {

  @Output() sendOrden = new EventEmitter();
  @Input() numero_decimales: number = 2;
  public title: String;
  public ordenes: Array<OrdenCompra> = [];
  public selectedRow: number;
  private orden:OrdenCompra;
  public pagination: Pagination;
  public loading = false;
  public format_decimal: String;
  public text: String;

  constructor(
    public ordenService: OrdenCompraService,
    public bsModalRef: BsModalRef
  ) {
    this.title = "Ordenes de compra";
    this.pagination = new Pagination();
    this.format_decimal = "0,0.00";
    this.text = "";
  }

  ngOnInit() {
    let digitos = "";
    for (let i = 0; i < this.numero_decimales; i++) digitos += "0";
    this.format_decimal = "0,0." + digitos

    this.getOrdenes();
  }

  getOrdenesBySearch(text) {
    this.text= text;
    let qs = this.getQs();
    this.pagination.current_page = 1;
    this.getOrdenes(qs);
  }

  getQs(){
		return "&q[secuencial]=" + this.text + "&q[razon_social]=" + this.text + "&q[nombre_comercial]=" + this.text;
	}

  getOrdenes(qs = "") {
    this.loading = true;
    this.ordenService.getModalOrden('?page=' + this.pagination.current_page + '&per_page=10' + qs).subscribe(
      res => {
        this.ordenes = res.data;
        this.loading = false;

        this.pagination.current_page = res.current_page;
        this.pagination.from = res.from;
        this.pagination.to = res.to;
        this.pagination.total = res.total;
        this.pagination.last_page = res.last_page;
        this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
        this.pagination.prev_disabled = this.pagination.current_page === 1;
      },
      err => {
        this.ordenes = [];
        this.loading = false;
      }
    );
  }

  onSelectRow(orden, i) {
    this.selectedRow = i;
    this.orden = orden;
  }

  onDBLClick(orden, i) {
    this.onSelectRow(orden, i);
    this.onSubmit();
  }

  onSubmit() {
    this.sendOrden.emit(this.orden);
    this.bsModalRef.hide();
  }

  next() {
    let qs = "";
		if(this.text != ""){
			qs = this.getQs();
		}
    this.pagination.current_page++;
    this.getOrdenes(qs);
  }

  prev() {
    let qs = "";
		if(this.text != ""){
			qs = this.getQs();
		}
    this.pagination.current_page--;
    this.getOrdenes(qs);
  }

  first() {
    let qs = "";
		if(this.text != ""){
			qs = this.getQs();
		}
    this.pagination.current_page = 1;
    this.getOrdenes(qs);
  }

  last() {
    let qs = "";
		if(this.text != ""){
			qs = this.getQs();
		}
    this.pagination.current_page = this.pagination.last_page;
    this.getOrdenes(qs);
  }

  get formatDecimal() {
    return this.format_decimal;
  }


}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/orden-compra-add-modal/orden-compra-add-modal.component.ts